const postOnboarding = async (url, {
  arg
}) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(arg)
  });
  if (!response.ok) {
    throw new Error(`Onboarding request failed: ${response.status} ${response.statusText}`);
  }
  return response.json();
};
export default postOnboarding;